import signatures from './signatures';
import statusHeader from './statusHeader';

const documentShow = {
  signatures,
  statusHeader,
};

export default documentShow;
